<template>
  <section id="channelView" class="statv_container statv_page_bg">
    <div class="channel_wrapper statv_wrapper">
      <h1 class="channel_title"> 채널번호 </h1>
			<article class="channel_box">
				<figure class="channel_item"
					v-for="(channel, idx) in channels" :key="`channel_${idx}`">
					<h3 class="channel_name"> {{channel.name}} </h3>
					<p class="channel_number"> {{channel.number}} </p>
				</figure>
			</article>
      <cable-view></cable-view>
    </div>
  </section>
</template>
<script>
import * as Store from '@/store/modules/channel'
import CableView from './Cable.vue'
export default {
  components: {
    CableView
  },
  data() {
    return {

    }
  },
  async created() {
    this.getChannels()
  },
  computed: {
    ...Store.mapState([
      "channels"
    ])
  },
  methods: {
    ...Store.mapActions([
      "getChannels"
    ])
  }
}
</script>
<style lang="less">
.statv_page_bg {
	min-height: 0 !important;
}
#channelView {
	.channel_wrapper {
		background-color: #ffffff;
		display: flex;
		flex-flow: column wrap;
		.channel_title {
			display: flex;
			margin-top: 70px;
			padding-bottom: 30px;
			justify-content: center;
			align-items: center;
			color: #ff6400;
			font-size: 42px;
			font-weight: 900;
		}
		.channel_box {
			display: flex;
			flex-flow: row wrap;
			justify-content: center;
			width: 100%;
			.channel_item {
				display: flex;
				flex: 1 0 0;
				flex-flow: column wrap;
				justify-content: center;
				align-items: center;
				color: #ff6400;
				border-right: 2px solid #ff6400;
				letter-spacing: 0;
				&:last-child {
					border: none;
				}
				.channel_name {
					font-size: 22px;
					font-weight: 900;
					padding-bottom: 10px;
				}
				.channel_number {
					font-size: 36px;
					font-weight: 900;
					&::before {
						content: "ch";
						font-size: 36px;
						font-weight: 400;
					}
				}
			}
		}
	}
}

.m #channelView { 
	.channel_wrapper {
		padding-bottom: 160px;
		.channel_title {
			margin-top: 105px;
			padding-bottom: 75px;
			font-size: 50px;
		}
	}
}

</style>